import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: [],
    balanceCurrencies: [],
    balanceReport: []
};
function accountResource(data) {
    var broker = {
        id: data.broker.id,
        name: data.broker.name,
        separator: data.broker.separator,
        hasUniqueTradeId: data.broker.hasUniqueTradeId
    };
    return {
        id: data.id,
        name: data.name,
        key: data.key,
        secret: data.secret,
        passphrase: data.passphrase,
        broker: broker,
        pair: data.pair,
        client: data.client,
        main: data.main,
        type: data.type,
        mainAccount: data.mainAccount
    };
}
function balanceCurrenciesResource(data) {
    var broker = {
        id: data.broker.id,
        name: data.broker.name,
        separator: data.broker.separator,
        hasUniqueTradeId: data.broker.hasUniqueTradeId
    };
    return {
        id: data.id,
        name: data.name,
        convert: data.convert,
        broker: broker,
        unique: data.unique
    };
}
export var Reducer = createSlice({
    name: 'account',
    initialState: initialState,
    reducers: {
        set: function set(state, accounts) {
            var data = [];
            accounts.payload.forEach(function (item) {
                data[item.id] = accountResource(item);
            });
            state.data = data;
        },
        add: function add(state, account) {
            state.data.push(accountResource(account.payload));
        },
        del: function del(state, id) {
            state.data.splice(id.payload, 1);
        },
        update: function update(state, account) {
            state.data[account.payload.id] = accountResource(account.payload);
        },
        setBalanceCurrencies: function setBalanceCurrencies(state, currencies) {
            var data = [];
            currencies.payload.forEach(function (item) {
                data[item.id] = balanceCurrenciesResource(item);
            });
            state.balanceCurrencies = data;
        }
    }
});
var _Reducer$actions = Reducer.actions, add = _Reducer$actions.add, set = _Reducer$actions.set, del = _Reducer$actions.del, update = _Reducer$actions.update, setBalanceCurrencies = _Reducer$actions.setBalanceCurrencies;
export { add, set, del, update, setBalanceCurrencies };
export default Reducer.reducer;
